<template>
  <div class="catalogTypes">
    <default-header :h2="$t('catalogModels.title')" />
    <back-btn></back-btn>

    <div class="innerContent justifyContentFlexStart">
      <h6 class="testResult__title mt-2 mb-2">{{$t('catalogModels.chooseUpBatteries')}}</h6>
      <div v-if="!detailsView" class="catalogTypes__img">
        <img v-if="!modelTypes.image" src="../assets/battery_placeholder.png" />
        <img v-else :src="modelTypes.image" />
        <div>{{ modelTypes.groupName }}</div>
      </div>

      <div v-if="detailsView" class="catalogTypes__img">
        <img
          v-if="!modelTypes.batteries[activeIndex].image"
          src="../assets/battery_placeholder.png"
        />
        <img v-else :src="modelTypes.batteries[activeIndex].image" />
        <div>{{ modelTypes.groupName }}</div>
      </div>

      <!-- LIST -->
      <div
        v-if="!detailsView"
        @click="goToDetails(type, index)"
        class="catalogTypes__item"
        v-for="(type, index) in modelTypes.batteries"
        :key="index"
      >
        <div class="catalogTypes__item-text">
          <div class="catalogTypes__item-text__name">{{ $t('report.part') +' #'+type.model }}</div>
          <div
            class="catalogTypes__item-text__subname"
          >{{ $t('report.cca') + ' #'+type.parameters.cca }}</div>
          <div
            class="catalogTypes__item-text__subname"
          >{{ $t('report.capacity') + ' #'+type.parameters.capacity }}</div>
        </div>
        <div
          class="catalogTypes__item-arrow"
          :class="checkIfIsInChosenBatteries(type.id) ? 'chosen' : ''"
        >
          <font-awesome-icon
            v-if="checkIfIsInChosenBatteries(type.id)"
            :icon="['fas', 'check-circle' ]"
          />
          <font-awesome-icon v-else :icon="['fas', 'arrow-circle-right' ]" />
        </div>
      </div>

      <!-- CHOSEN -->
      <div v-if="detailsView" class="pl-1 pr-1">
        <h6 class="testResult__title mt-2 mb-4">
          {{ $t('report.part') +' #'+ modelTypes.batteries[activeIndex].model + ' - ' + $t('report.cca') + ' #'+ modelTypes.batteries[activeIndex].parameters.cca + ' - '+ $t('report.capacity') + ' #'+
          modelTypes.batteries[activeIndex].parameters.capacity }}
        </h6>
        <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('catalogModelList.boxSize')}}</div>
          <div
            class="catalogTypes__item-text__name"
          >{{ modelTypes.batteries[activeIndex].parameters.holdDown }}</div>
        </div>
        <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('catalogModelList.height')}}</div>
          <div
            class="catalogTypes__item-text__name"
          >{{ modelTypes.batteries[activeIndex].parameters.height + " mm" }}</div>
        </div>
        <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('catalogModelList.width')}}</div>
          <div
            class="catalogTypes__item-text__name"
          >{{ modelTypes.batteries[activeIndex].parameters.width + " mm" }}</div>
        </div>
        <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('catalogModelList.length')}}</div>
          <div
            class="catalogTypes__item-text__name"
          >{{ modelTypes.batteries[activeIndex].parameters.length + " mm" }}</div>
        </div>
        <!-- <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('catalogModelList.startStop')}}</div>
          <div class="catalogTypes__item-text__name">{{$t('general.yes')}}</div>
        </div>-->
        <div class="catalogTypes__itemText">
          <div class="catalogTypes__item-text__name">{{$t('general.voltage')}}</div>
          <div
            class="catalogTypes__item-text__name"
          >{{ modelTypes.batteries[activeIndex].parameters.voltage + " V" }}</div>
        </div>
        <button
          :class="[checkIfIsInChosenBatteries(modelTypes.batteries[activeIndex].id) ? 'chosenBtn' : '']"
          @click="toggleAddingToChosenBatteries(modelTypes.batteries[activeIndex])"
          class="btn btn-primary mt-3 w-100 pl-1 pr-1"
        >
          <font-awesome-icon
            v-if="checkIfIsInChosenBatteries(modelTypes.batteries[activeIndex].id)"
            :icon="['fas', 'check' ]"
          />
          {{ checkIfIsInChosenBatteries(modelTypes.batteries[activeIndex].id) ? $t('general.selected') : $t('general.select') }}
        </button>
        <button
          @click="detailsView = 0"
          class="btn btn-outline-primary btn-block mt-2 mb-2 pl-1 pr-1"
        >{{$t('catalogModelList.backList')}}</button>
      </div>

      <div class="pl-1 pr-1">
        <button
          v-if="detailsView === 0"
          @click="$router.push({name: 'CatalogModels'})"
          class="btn btn-outline-primary btn-block mt-5 mb-2 pl-1 pr-1"
        >{{$t('catalogModelList.backModels')}}</button>
        <button
          @click="$router.push({name: 'TestResult'})"
          class="btn btn-primary btn-block mb-2"
        >{{$t('catalogModelList.backToTestResult')}}</button>
        <button
          @click="$router.push({name: 'AddOtherBatteryModel'})"
          class="btn btn-outline-primary btn-block w-75 mt-2 mb-2 ml-auto mr-auto"
        >
          <font-awesome-icon :icon="['fas', 'keyboard' ]" />
          <span style="padding-left:10px;">{{$t('catalogModelList.OtherBatteryModel')}}</span>
        </button>
      </div>
    </div>

    <bottom-navigation />
  </div>
</template>

<script>
import DefaultHeader from '../partials/DefaultHeader';
import BottomNavigation from '../partials/BottomNavigation';
import { mapActions, mapGetters } from 'vuex';
import BackBtn from '../components/BackBtn';
export default {
  name: 'CatalogModelList',
  components: {
    DefaultHeader,
    BottomNavigation,
    BackBtn
  },
  data() {
    return {
      detailsView: 0,
      activeIndex: 0
    };
  },
  computed: {
    ...mapGetters({ modelTypes: 'getModelTypes' }),
    ...mapGetters({ chosenBatteries: 'getChosenBatterries' }),
    ...mapGetters({ activeBrand: 'getActiveBrand' })
  },
  beforeMount() {
    if (this.$store.state.catalog.modelTypes.length === 0) {
      this.$router.push({ name: 'CatalogModels' });
      return;
    }
  },
  methods: {
    ...mapActions(['fetchModelTypes']),
    goToDetails(type, index) {
      this.activeIndex = index;
      this.detailsView = type.id;
    },
    toggleAddingToChosenBatteries(battery) {
      const alreadyChosen = this.chosenBatteries.some(chosen => chosen.id === battery.id);
      if (!alreadyChosen) {
        if (this.chosenBatteries.length < 3) {
          this.$store.commit('addToChosenBatteries', {
            manufacturer: this.activeBrand,
            id: battery.id,
            image: battery.image,
            model: battery.model,
            capacity: battery.parameters.capacity + 'Ah',
            cost_separately: false,
            service_price: 0,
            battery_price: 0,
            comment: '',
            tecdoc_id: battery.id
          });
          this.$toasted.show(this.$i18n.t('testResult.batteryAddedToQuote'), {
            className: 'success'
          });

          return;
        }
        this.$toasted.show(this.$i18n.t('otherBattery.batteryIsAlreadyAddedToQuote'));
      } else {
        this.$store.commit('removeFromChosenBatteries', battery);
      }
    },
    checkIfIsInChosenBatteries(id) {
      return this.chosenBatteries.some(chosen => chosen.id === id);
    }
  }
};
</script>

<style scoped lang="scss">
</style>
